/**
 * msalConfig.js
 * MSAL configuration for NAA (Nested App Authentication).
 *
 * NAA uses createNestablePublicClientApplication — Office acts as the broker.
 * Azure App Registration requires: brk-multihub://localhost:3000 as SPA redirect URI.
 */

export const CLIENT_ID = "a04bc09c-1cc8-488a-b9bc-b6b099803d65";

export const msalConfig = {
  auth: {
    clientId: CLIENT_ID,
    authority: "https://login.microsoftonline.com/common",
  },
  cache: {
    cacheLocation: "localStorage",
  },
  system: {
    allowNativeBroker: false,    // OS broker (WAM) disabled — Office broker is used instead
    supportsNestedAppAuth: true, // Enables the NAA path in MSAL v5
  },
};

export const msalScopes = ["openid", "profile"];
